/* eslint-disable no-use-before-define */
import React from 'react'
import { STEPS, useCalculator } from './use-calculator'

export const Navigation = () => {

    const { step } = useCalculator()
    const r = getLabels(step)

    return <nav className="minimal-navigation">
        <div className="row vertical-offset-xs">
        <div className="col-xs-12 vertical-offset-xs">
            <a href="https://etrade.com"><img src="resources/images/logo.svg" alt="etrade" width="150" /></a>
        </div>
        </div>
        <div className="row">
        <div className='col-xs-12'>
            <div className="progress" role="progressbar"
                aria-label="Progress"
                aria-valuenow={r.value}
                aria-valuemin="1"
                aria-valuemax="3">
                <div className="progress-bar" style={{width:r.width}}></div>
            </div>
        </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-xs-12 text-center text-muted">
            <span>{r.label}</span>
        </div>
        </div>
    </nav>
}


const getLabels = (step) => {
    switch(step) {
    case STEPS.UNKNOWN:
        return {
            label: "Unexpected State/Error",
            value: 0,
            width: '0%',
        }
    case STEPS.CALC_INPUT:
    case STEPS.CALC_ERROR:
    case STEPS.CALC_LOADING:
        return {
            label: "Step 2 of 3: Calculate price/yield",
            value: 2,
            width: '67%',
        }
    case STEPS.CALC_OUTPUT:
        return {
            label: "Step 3 of 3: Review results and next steps",
            value: 3,
            width: '100%',
        }
    case STEPS.INIT:
    case STEPS.INIT_LOADING:
    case STEPS.INIT_ERROR:
    case STEPS.CUSIP_INPUT:
    case STEPS.CUSIP_ERROR:
    case STEPS.CUSIP_LOADING:
    default:
        return {
            label: "Step 1 of 3: Enter CUSIP",
            value: 1,
            width: '33%',
        }
    }

}
